import { Outlet, useNavigate } from "react-router-dom";

import { useViewerContext } from "@/hooks/useViewerContext";

const ReportsRoute = () => {
    const { viewer } = useViewerContext();
    const navigate = useNavigate();

    if (!viewer?.commentator) {
        return (
            <div className="mt-10 flex flex-col items-center space-y-2">
                <div>You need to be a commentator in order to visit this route.</div>
                <button
                    onClick={() => {
                        navigate("/settings");
                    }}
                    className="rounded bg-blue-200 px-4 py-2"
                >
                    Create commentator profile
                </button>
            </div>
        );
    }

    return <Outlet />;
};

export default ReportsRoute;
